import React from 'react';

import {Modal} from '@mantine/core';

type Props = {
    data?: {
        title: string;
        form: React.ElementType<{close: () => void}>;
    };
    close: () => void;
};

export const CustomModal = (props: Props) => {
    return (
        <Modal
            title={props.data?.title || ''}
            opened={Boolean(props.data)}
            onClose={props.close}
            closeOnClickOutside={false}
            withCloseButton={true}
        >
            {props.data && (
                <props.data.form
                    close={props.close}
                />
            )}
        </Modal>
    );
}
